module.exports = "/assets/data/06e284d3e5b667921c57ad107f6dcf3a-DN11.data.json";